export const API_BASE = import.meta.env.PROD 
  ? 'https://safenav-dg88.onrender.com'
  : 'http://localhost:3001';
